// file created at 2020-3-4
// Auto-generated files ImagePaletteWidget.ts

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Palette from '@/interfaces/Palette';
import { sortForDisplay } from '@/utils/palette-utils';
import Datum from '@/interfaces/Datum';

@Component({})
export default class ImagePaletteWidget extends Vue {
  public $refs!: {
    vImg: Element;
    maskCanvas: HTMLCanvasElement;
  };


  @Prop() protected src!: string;
  @Prop() private palette!: Palette;
  @Prop() private mouseoverNode!: d3.HierarchyPointNode<Datum>;

  @Watch('mouseoverNode')
  protected mouseoverNodeChanged() {
    const canvasEl: HTMLCanvasElement = this.$refs.maskCanvas;
    const ctx = canvasEl.getContext('2d')!;
    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);

    if (!this.mouseoverNode || !this.mouseoverNode.data.layer) { return; }

    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, canvasEl.width, canvasEl.height);

    const width = 1000;
    const height = 667;

    let [rows, cols] = this.mouseoverNode.data.layer;
    rows = rows.map(v => Math.floor(v / (height - 1) * (canvasEl.height - 1)));
    cols = cols.map(v => Math.floor(v / (width - 1) * (canvasEl.width - 1)));

    let i = 0;
    const len = rows.length;
    const points = new Map<string, boolean>();
    for (i = 0; i < len; i += 1) {
      const row = rows[i];
      const col = cols[i];
      const key = `${row},${col}`;
      points.set(key, true);
    }
    ctx.globalCompositeOperation = 'xor';
    ctx.fillStyle = '#FFFFFF';
    for (const point of points.keys()) {
      const [row, col] = point.split(',');
      ctx.fillRect(+col, +row, 1, 1);
    }
  }

  protected get sortedPalette() {
    return sortForDisplay([...this.palette]);
  }

  protected mounted() {
    //
  }
}
